var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _vm.modalData
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalData,
                expression: "modalData",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.acceptModal,
              modalData: _vm.modalData,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h5", { staticClass: "inline" }, [
            _vm._v("ЕГК коды в игнорировании"),
          ]),
          _vm._v(" "),
          _vm.paginator
            ? _c("span", [
                _vm._v("Всего: "),
                _c("strong", [_vm._v(_vm._s(_vm.paginator.total))]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row search_row" }, [
            _c("div", { staticClass: "col-md-8" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-info",
                  attrs: { type: "button" },
                  on: { click: _vm.refreshCodes },
                },
                [_vm._v("Обновить")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c(
                "form",
                { attrs: { action: "" }, on: { submit: _vm.searchSubmit } },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search,
                          expression: "search",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Поиск..." },
                      domProps: { value: _vm.search },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.search = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm._m(0),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "form",
              { attrs: { action: "" } },
              [
                _c("codesTable", { attrs: { tableRecords: _vm.records } }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _vm.paginator
                      ? _c("paginate", {
                          attrs: {
                            "page-count": _vm.paginator.last_page,
                            "page-range": 11,
                            "margin-pages": 2,
                            "click-handler": _vm.getRecords,
                            "prev-text": "&laquo",
                            "next-text": "&raquo",
                            "container-class": "pagination",
                            "prev-class": "page-item",
                            "prev-link-class": "page-link",
                            "page-class": "page-item",
                            "page-link-class": "page-link",
                            "next-class": "page-item",
                            "next-link-class": "page-link",
                            "active-class": "active green_btn",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-info",
                          attrs: { type: "button" },
                          on: { click: _vm.clearIgnore },
                        },
                        [_vm._v("Сбросить с игнорирования")]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "button",
        { staticClass: "btn btn-success", attrs: { type: "submit" } },
        [_vm._v("Поиск")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }